import { render, staticRenderFns } from "./CoreData.vue?vue&type=template&id=2ae64bd2&scoped=true"
import script from "./CoreData.vue?vue&type=script&lang=js"
export * from "./CoreData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae64bd2",
  null
  
)

export default component.exports